import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { Noise } from './ui/Noise';

export const Layout = () => {
  return (
    <main className="relative w-full min-h-screen bg-background text-ink overflow-x-hidden">
      <Noise />
      <Navbar />
      <Outlet />
      <Footer />
    </main>
  );
};
